import React, { Component } from "react"
import { Button, TextareaAutosize, Typography } from "@material-ui/core"
import { Link } from "react-router-dom"

import ScheduleTable from "../../../components/Table/ScheduleTable"
import SectionHeader from "../../../components/SectionHeader"
import rebase from "../../../config/rebase"
import { dbPrefix, knowledgeAreaArray } from "../../../Constants"
import Wrapper from "../../../components/Common/Wrapper"
import { getUsersByUID, isPaperGradesAvailable } from "../../../utils"
import CustomBtn from "../../../components/Buttons/CustomBtn"
import CustomCardItem from "../../../components/Cards/CustomCardItem"

class Papers extends Component {

  state = {
    learnMoredialog: false,
    getStartedDialog: false,
    noBannerAutorsEmails: [],
    papers: [],
  }

  columns = [
    {
      name: "paperTitle",
      label: "Nome",
      options: {
        filter: false
      }
    },
    {
      name: "knowledgeArea",
      label: "Área de Conhecimento",
      options: {
        customBodyRender: (val) => {
          const area = knowledgeAreaArray.find(k => val === k.value)
          return <span>{area.title}</span>
        }
      }
    },
    {
      name: "finalGrade",
      label: "Nota",
      options: {
        customBodyRender: (val) => {
          return !isNaN(val) ? val : "-"
        }
      }
    },
    {
      name: "bannerURL",
      label: "Banner depositado?",
      options: {
        customBodyRender: (val) => {
          return val ? 'Sim' : "Não"
        }
      }
    },
    {
      name: "usersId",
      options: {
        customBodyRender: (val) => {
          return val.join(', ')
        }
      }
    },
    {
      name: "Visualizar",
      options: {
        filter: false,
        sort: false,
        customBodyRenderLite: (index) => {
          return (
            <Button
              variant="outlined"
              color="secondary"
              fullWidth
              component={Link}
              to={"/admin/ver-paper/" + this.state.papers[index].key}>
              &#8594;
            </Button>
          )
        }
      }
    }

  ];

  componentDidMount() {
    rebase.fetch(dbPrefix + 'papers', {
      asArray: true
    }).then(data => {
      const noBanner = data.filter(e => e.accepted && e.banner && !e.bannerURL).length
      console.log(data);
      rebase.fetch(dbPrefix + 'users', {
        asArray: true,
      }).then(users => {

        data.map(p => {
          p.usersId = p.usersId.map(u => {
            const user = users.find(user => user.key === u)
            return user ? user.uEmail : 'Usuário não encontrado'
          })
        })
        this.setState({ papers: data, noBanner })
      })
    }).catch(error => {
      console.log(error)
      this.setState({ fatalError: 'Ocorreu um erro' })
    }).finally(() => {
      this.setState({ loaded: true })
    })
  }

  handleClick() {
    this.props.history.push(`/admin/finalizacao`)
  }
  async getNoBannerAutorsEmails() {
    try {
      this.setState({ loaded: false })

      const usersId = new Set()
      for (const paper of this.state.papers) {
        paper.usersId.map(u => usersId.add(u))
      }

      const usersArr = await getUsersByUID([...usersId])
      const noBannerAutorsEmails = usersArr.map(u => u.uEmail).join(', \n')
      this.setState({ noBannerAutorsEmails })

    } catch (error) {
      this.setState({ fatalError: 'Ocorreu um erro' })
    } finally {
      this.setState({ loaded: true })
    }
  }

  render() {

    return (
      <Wrapper loaded={this.state.loaded} fatalError={this.state.fatalError} currentPath={this.props.location.pathname} adminTopbar>
        <br />
        <br />
        {
          isPaperGradesAvailable() && <CustomBtn onClick={() => this.handleClick.bind(this)()} title={"Finalização (notas e cronograma)"} />
        }
        <SectionHeader
          title="Trabalhos"
          subtitle="A tabelas abaixo lista todos os trabalhos"
        />
        <Typography variant="h3">Quantitativo</Typography>
        <CustomCardItem>
          <Typography>Trabalhos de <i>banner</i> sem <i>banner</i>: {this.state.noBanner}</Typography>
          {!this.state.noBannerAutorsEmails.length ?
            <CustomBtn onClick={() => this.getNoBannerAutorsEmails.bind(this)()} title="Gerar e-mails de autores que não despositaram seus banners" />
            :
            <>
              <Typography>E-mails de autores que não despositaram seus <i>banners</i></Typography>
              <TextareaAutosize
                value={this.state.noBannerAutorsEmails}
                disabled
              />
            </>
          }
        </CustomCardItem>
        <ScheduleTable data={this.state.papers} columns={this.columns} title={"Trabalhos Cadastrados"} />
      </Wrapper>
    )
  }
}

export default Papers
